module.exports = {"659002001":"金银川路街道","659002002":"幸福路街道","659002003":"青松路街道","659002100":"金银川镇","659002101":"新井子镇","659002102":"甘泉镇","659002103":"永宁镇","659002104":"沙河镇","659002105":"双城镇","659002106":"花桥镇","659002107":"幸福镇","659002108":"金杨镇","659002109":"玛滩镇","659002110":"塔门镇","659002111":"梨花镇","659002112":"昌安镇","659002113":"塔南镇","659002114":"新开岭镇","659002200":"托喀依乡","659002402":"工业园区","659002518":"西工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/659002.json
// module id = 3294
// module chunks = 0